import { configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

import { envChecklistReducer } from "@/features/environmentalChecklist";
import { imageReducer } from "@/features/imageUpload";
import { ltssMedRoomFormReducer } from "@/features/medRoomChecklist";
import { apiSlice } from "@/lib/rtkquery";
import { formReducer } from "@/store/FormSlice";
import { formStateReducer } from "@/store/FormStateSlice";
import { locationReducer } from "@/store/LocationSlice";

export const store = configureStore({
  reducer: {
    form: formReducer,
    formState: formStateReducer,
    location: locationReducer,
    ltssMedRoomForm: ltssMedRoomFormReducer,
    envChecklistForm: envChecklistReducer,
    image: imageReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(
      apiSlice.middleware,
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
